import { apiClient } from '@shared/utils/api-client';
import type { ExtraRule, CreateExtraRuleDto } from '../types';

export const extrasApi = {
  getAll: async (): Promise<ExtraRule[]> => {
    return apiClient.get<ExtraRule[]>('/extras');
  },

  getOne: async (id: number): Promise<ExtraRule> => {
    return apiClient.get<ExtraRule>(`/extras/${id}`);
  },

  create: async (data: CreateExtraRuleDto): Promise<ExtraRule> => {
    return apiClient.post<ExtraRule>('/extras', data);
  },

  delete: async (id: number): Promise<void> => {
    return apiClient.delete(`/extras/${id}`);
  },
};
